import { render, staticRenderFns } from "./ticketView.vue?vue&type=template&id=6625b1e2"
import script from "./ticketView.vue?vue&type=script&lang=js"
export * from "./ticketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports